import { useCallback } from 'react';
import { AddStandardItemModal } from '@/components/modals/AddStandardItemModal';

export interface DispositionOption {
  dispositionCode: number;
  dispositionValue: string;
}

export interface AddStandardDispositionModalProps {
  open: boolean;
  availableDispositions: DispositionOption[];
  loading?: boolean;
  theme?: string;
  onSave: (data: { dispositionCodes: number[] }) => void;
  onCancel: () => void;
}

export function AddStandardDispositionModal({
  open,
  availableDispositions = [],
  loading,
  theme,
  onSave,
  onCancel,
}: AddStandardDispositionModalProps) {
  const handleSave = useCallback((selectedCodes: number[]) => {
    onSave({ dispositionCodes: selectedCodes });
  }, [onSave]);

  return (
    <AddStandardItemModal
      open={open}
      availableItems={availableDispositions}
      loading={loading}
      itemLabelKey="dispositionValue"
      itemValueKey="dispositionCode"
      title="Add Standard Call Disposition"
      fieldLabel="Dispositions to add"
      placeholder="Select Call Dispositions..."
      requiredMessage="Disposition(s) required."
      theme={theme}
      onSave={handleSave}
      onCancel={onCancel}
    />
  );
}

(window as any).AddStandardDispositionModalReact = AddStandardDispositionModal;
